export const BACKEND_DOMAIN_PROD =
  "https://4pqb465jei.us-east-1.awsapprunner.com";

export const BACKEND_DOMAIN_UAT =
  "https://vpmmk7zefk.us-east-1.awsapprunner.com";

export const BACKEND_DOMAIN_LOCALHOST = "http://localhost:8080";
